"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getWestVirginiaRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _Rule = require("../Rule");

var _types = require("../../assets/types");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'WV';

function getWestVirginiaRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Teachers Pension',
    type: stateCode,
    statuteName: 'W. Va. Code § 18-7A-30',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.TEACHERS_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: "Workers' Compensation",
    type: stateCode,
    statuteName: 'W. Va. Code § 23-4-18',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal Benefits',
    type: stateCode,
    statuteName: 'W. Va. Code § 33-23-21',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FRATERNAL_BENEFIT];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (group)',
    type: stateCode,
    statuteName: 'W. Va. Code § 33-6-28',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.GROUP_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Motor Vehicle (one)',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (b)',
    limitAggregateSingle: 2400,
    limitAggregateJoint: 4800,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      return this.canTakeMoreExemptions() && type === _types.VEHICLE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Household Goods and Furnishings. ' + 'Books, Antiques, Art, Collectibles. ' + 'Hobby Equipment. ' + 'Wearing Apparel. ' + 'Animals. ' + 'Crops.',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (c)',
    limitAggregateSingle: 8000,
    limitAggregateJoint: 16000,
    // NOTE: The norm is that lawyers list all household goods together, not itemized even though that's the statute.
    // limitPerItem: 400,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.HOUSEHOLD, _subTypes.BOOK, _subTypes.ANTIQUE, _subTypes.ARTWORK, _subTypes.COLLECTIBLES, _subTypes.SPORTS_OR_HOBBY_EQUIPMENT, _subTypes.CLOTHES, _subTypes.PERSONAL_ANIMALS, _subTypes.CROPS, _subTypes.ELECTRONICS];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Jewelry',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (d)',
    limitAggregateSingle: 1000,
    limitAggregateJoint: 2000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.JEWELRY, _subTypes.WATCH, _subTypes.WEDDING_RINGS];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Office Equipment & Supplies. Machinery, Fixtures, Equipment & Supplies',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (f)',
    limitAggregateSingle: 1500,
    limitAggregateJoint: 3000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.OFFICE_EQUIPMENT || subType === _subTypes.MACHINERY);
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (unmatured)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (g)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNMATURED_TERM_INSURANCE_POLICY;
    }
  }, // NOTE: Not sure what to do with loans
  // {
  //   id: idCounter.increment(),
  //   description: 'Life Insurance (unmatured, loan)',
  //   requiresReview: true,
  //   type: stateCode,
  //   statuteName: 'W. Va. Code § 38-10-4 (h); 11 U.S.C. § 542 (d)',
  //   limitAggregateSingle: Number.MAX_SAFE_INTEGER,
  //   limitAggregateJoint: Number.MAX_SAFE_INTEGER,
  //   limitPerItem: Number.MAX_SAFE_INTEGER,
  //   assetLimit: Number.MAX_SAFE_INTEGER,
  //   canApply(asset: Asset) {
  //     const tertiaryType = _.get(asset, 'assetJSON.tertiaryType');
  //     return this.canTakeMoreExemptions()
  //       && tertiaryType === UNMATURED_TERM_INSURANCE_POLICY;
  //   },
  // },
  {
    id: idCounter.increment(),
    description: 'Health aids',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (i)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public assistance',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (j)(1)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.SOCIAL_SECURITY, _tertiaryTypes.UNEMPLOYMENT_COMPENSATION];
      return this.canTakeMoreExemptions() && (subType === _subTypes.PUBLIC_ASSISTANCE || validTertiaryTypes.includes(tertiaryType));
    }
  }, {
    id: idCounter.increment(),
    description: "Veterans' Benefit",
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (j)(2)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Health or disability benefits',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (j)(3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony or Maintenance Support',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (j)(4)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    description: 'ERISA (employee retirement account). Private Pension Plans. Annuities',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (j)(5)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.ANNUITY || tertiaryType === _tertiaryTypes.PRIVATE_PENSION_PLAN || tertiaryType === _tertiaryTypes.ERISA_REITREMENT_PLAN);
    }
  }, {
    id: idCounter.increment(),
    description: 'IRA & Roth IRA',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (j)(5); 11 U.S.C. § 522(b)(3)(C)(n)',
    limitAggregateSingle: 1245475,
    limitAggregateJoint: 2490950,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.ROTH_IRA || subType === _subTypes.IRA);
    }
  }, {
    id: idCounter.increment(),
    description: "Crime Victims' Compensation",
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (k)(1)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wrongful death awards',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (k)(2)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WRONGFUL_DEATH_AWARD;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (for support)',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (k)(3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _tertiaryTypes.WHOLE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal Injury Settlement',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (k)(4)',
    limitAggregateSingle: 15000,
    limitAggregateJoint: 30000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Lost Future Earnings',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (k)(5)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.LOSS_OF_FUTURE_EARNINGS_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Tuition Trust Fund',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (k)(6)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.TUITION_TRUST;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unpaid wages - 80% or 30 times the federal min hourly wage per week',
    requiresReview: true,
    type: stateCode,
    statuteName: 'W. Va. Code § 38-5A-3',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.UNPAID_WAGES;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unripe Crops',
    type: stateCode,
    statuteName: 'W. Va. Code § 38-8-14',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CROPS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Partnerships',
    type: stateCode,
    statuteName: 'W. Va. Code § 47B-5-4',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PARTNERSHIP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public employees',
    type: stateCode,
    statuteName: 'W. Va. Code § 5-10-46',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTypes = [_tertiaryTypes.PUBLIC_EMPLOYEE_PENSION];
      return this.canTakeMoreExemptions() && validTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Judges\' Retirement benefits',
    type: stateCode,
    statuteName: 'W. Va. Code § 51-9-14',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.JUDGES_PENSIONS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Blind Aged Disabled assistance',
    type: stateCode,
    statuteName: 'W. Va. Code § 9-5-1',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.AID_TO_BLIND;
    }
  }, {
    id: _Rule.WILDCARD_ID,
    description: 'Wildcard',
    requiresReview: true,
    type: stateCode,
    statuteName: 'W. Va. Code § 38-10-4 (e)',
    limitAggregateSingle: 25800,
    limitAggregateJoint: 51600,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}